<template>
  <legend-map ref="legendMapRef" legend-code="zone_metering_legend" :forbidden-list="['水厂范围']"
    :default-pitch-on="['片区范围示意图', '管线', '水厂范围', '分界阀门', '分区计量仪表']" @layer-click="handleLayerClick"
    @selected-id-change="handleSelectedIdChange" @legend-toggle="handleLegendToggle" />
</template>
<script>
import LegendMap from '../mapModule/LegendMap.vue'

export default {
  name: 'LegengMap',
  components: {
    LegendMap
  },
  methods: {
    // 处理图层点击事件
    handleLayerClick (data) {
      this.$emit('layer-click', data)
    },
    // 处理选中ID变化事件
    handleSelectedIdChange (data) {
      this.$emit('selected-id-change', data)
    },
    // 处理图例切换事件
    handleLegendToggle (visible) {
      this.$emit('legend-toggle', visible)
    },
    // 暴露给父组件调用的方法
    handleShowLegend () {
      if (this.$refs.legendMapRef) {
        this.$refs.legendMapRef.handleShowLegend()
      }
    }
  }
}
</script>
